import styles from "./BackgroundPages.module.scss";
import back from "./wave.png";

export const BackgroundPages = () => {
  return <img src={back} className={styles.content} />;
};
